// @flow
/* -----------------Globals--------------- */
import produce from 'immer';

/* -----------------Types--------------- */
import { UPDATE_BREADCRUMBS } from './actionTypes';
import type { StoreState } from './types';

/* -----------------Constants--------------- */
import { initialState } from './constants';

const setBreadcrumbs = (
  state: StoreState,
  data: *,
) => produce(state, (draft) => {
  const {
    name,
    category,
    numericId,
  } = data;
  const breadcrumbsValue = {
    name,
    category,
    numericId,
  };
  draft.breadcrumbs = breadcrumbsValue;
});

const storeReducer = (
  state: StoreState = {
    ...initialState,
  },
  action: *,
) => {
  switch (action.type) {
    case UPDATE_BREADCRUMBS:
      return setBreadcrumbs(state, action.data);
    default:
      return state;
  }
};

export default storeReducer;
